import { CENTS_IN_A_DOLLAR } from '@constants';
import { PriceWithDiscountRaw, Money, Price, PriceWithDiscount } from '@services';

export const convertCentAmount = (centAmount: number): number =>
  Number((centAmount / CENTS_IN_A_DOLLAR).toFixed(2));

export const mapMoney = (money: Money): Price => {
  const { centAmount, currencyCode } = money;
  const value = convertCentAmount(centAmount);

  const result: Price = {
    value,
    currencyCode
  };

  return result;
};

export const mapPriceFromArray = (prices: PriceWithDiscountRaw[]): PriceWithDiscount | null => {
  if (!prices.length) {
    return null;
  }
  const [ priceInfo ] = prices;

  const result = mapMoney(priceInfo.value) as PriceWithDiscount;

  if (priceInfo.discounted) {
    result.discountedValue = convertCentAmount(priceInfo.discounted.value.centAmount);
  }

  return result;
};
